const state = {
  pageTitle: "Dashboard",
};

const mutations = {
  setPageTitle(state, title) {
    state.pageTitle = title;
  },
};

const actions = {
  updatePageTitle({ commit }, title) {
    commit("setPageTitle", title);
  },
};

const getters = {
  pageTitle: (state) => state.pageTitle,
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
